import React from 'react';
import { connect } from 'react-redux';
import { Route, RouteComponentProps, Switch, withRouter } from 'react-router-dom';
import { ConditionedRoute } from './components/ConditionedRoute/ConditionedRoute';
import { defaultAuthState } from './core-module/models/redux/DefaultAuthState';
import Login from './containers/Pages/Login';
import NotFound from './containers/Pages/NotFound';
import AccessError from './containers/Pages/AccessError';
import { Dispatch } from 'redux';
import AdminDashboard from './containers/Pages/AdminDashboard';

interface AppRouterProps extends RouteComponentProps {
  auth: typeof defaultAuthState;
}

interface AppRouterProps extends RouteComponentProps {
  auth: typeof defaultAuthState;
  dispatch: Dispatch;
}

class AppRouter extends React.Component<AppRouterProps> {
  render() {
    const { auth } = this.props;

    return (
      <Switch>
        <ConditionedRoute
          exact={true}
          path={'/'}
          condition={!auth.isLoggedIn}
          alternatePath={'/app/'}
          component={Login}
        />
        <ConditionedRoute
          path='/dashboard/'
          condition={auth.isLoggedIn}
          alternatePath={'/'}
          component={AdminDashboard}
        />
        <Route path={`/geen-toegang`} component={AccessError} />
        <Route component={NotFound} />
      </Switch>
    );
  }
}

const mapStateToProps = ({ auth }) => ({ auth });

export default withRouter(connect(mapStateToProps)(AppRouter));
